module.exports = ".scroling{\n    overflow: auto !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/cms/about-us/about-us.component.css
// module id = ./src/app/cms/about-us/about-us.component.css
// module chunks = main